var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.25096C7.96907 5.18296 3.80007 7.99996 1.17907 10.885C0.903955 11.1904 0.751709 11.5869 0.751709 11.998C0.751709 12.409 0.903955 12.8055 1.17907 13.111C3.74307 15.935 7.90007 18.817 12.0001 18.748C16.1001 18.817 20.2581 15.935 22.8241 13.111C23.0992 12.8055 23.2514 12.409 23.2514 11.998C23.2514 11.5869 23.0992 11.1904 22.8241 10.885C20.2001 7.99996 16.0311 5.18296 12.0001 5.25096Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12C15.7498 12.7417 15.5297 13.4666 15.1175 14.0831C14.7054 14.6997 14.1196 15.1802 13.4344 15.4639C12.7491 15.7475 11.9952 15.8217 11.2678 15.6768C10.5404 15.532 9.87234 15.1748 9.348 14.6503C8.82365 14.1258 8.4666 13.4576 8.32198 12.7302C8.17737 12.0028 8.25169 11.2489 8.53555 10.5637C8.81941 9.87857 9.30005 9.29295 9.91672 8.88094C10.5334 8.46893 11.2584 8.24902 12 8.24902C12.4926 8.24889 12.9804 8.34583 13.4355 8.5343C13.8905 8.72277 14.304 8.99908 14.6523 9.34743C15.0006 9.69579 15.2768 10.1094 15.4651 10.5645C15.6535 11.0196 15.7503 11.5074 15.75 12Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.df94fd3841a133dc8e3f95af17e5229a.svg";
export { ForwardRef as ReactComponent };